module.exports = __webpack_public_path__ + "static/media/playfair-display-latin-500-normal.6f277609.woff2";